import { InlineBanner } from "components/InlineBanner";
import React, { memo } from "react";

/**
 * Render a banner allowing 'pay now' of overdue bill
 * or informing user of the results of 'pay now' attempt
 */
export const PayNowStatusBanner: React.FC<{
  handlePayNow: () => void;
  isOverdue: boolean;
  windcaveNavigatedBack: boolean;
  windcaveSuccess?: string;
}> = memo(
  ({ handlePayNow, isOverdue, windcaveNavigatedBack, windcaveSuccess }) => {
    if (windcaveSuccess === "true") {
      return <InlineBanner status="success" />;
    }

    if (windcaveNavigatedBack || windcaveSuccess === "false") {
      return (
        <InlineBanner
          status={"failedPayment"}
          onHandlePayNowClick={handlePayNow}
        />
      );
    }

    if (isOverdue) {
      return (
        <InlineBanner status="notice" onHandlePayNowClick={handlePayNow} />
      );
    }

    return <></>;
  },
);
